export const MLAppConfig = {
    RMDF_MDF_DETAILS: "ml/post-rmd-form",
    INVENTORY_UPDATE: "ml/post-inventory-updates"
}
